import { render } from "./addLandsdata.vue?vue&type=template&id=52d15d0c&scoped=true"
import script from "./addLandsdata.vue?vue&type=script&lang=js"
export * from "./addLandsdata.vue?vue&type=script&lang=js"

import "./addLandsdata.vue?vue&type=style&index=0&id=52d15d0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d15d0c"]])

export default __exports__